module.exports = __webpack_public_path__ + "res/19-img_play.43f62f76fe0434939e91d38c27b161f2.png";